import { useEffect, useRef, useState } from "react";

const ScrollFeedback = () => {
  const [counts, setCounts] = useState({ heart: 0, thumbsUp: 0 });
  const [isVisible, setIsVisible] = useState(false);
  const lastScrollY = useRef(0);
  const heartScroll = useRef(0);
  const thumbsUpScroll = useRef(0);
  const hideTimer = useRef(null);

  useEffect(() => {
    lastScrollY.current = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const distance = Math.abs(currentScrollY - lastScrollY.current);
      lastScrollY.current = currentScrollY;

      if (distance === 0) return;

      setIsVisible(true);
      heartScroll.current += distance;
      thumbsUpScroll.current += distance;

      const heartIncrease = Math.floor(heartScroll.current / 5);
      const thumbsUpIncrease = Math.floor(thumbsUpScroll.current / 9);
      heartScroll.current %= 5;
      thumbsUpScroll.current %= 9;

      if (heartIncrease > 0 || thumbsUpIncrease > 0) {
        setCounts((current) => ({
          heart: current.heart + heartIncrease,
          thumbsUp: current.thumbsUp + thumbsUpIncrease,
        }));
      }

      window.clearTimeout(hideTimer.current);
      hideTimer.current = window.setTimeout(() => setIsVisible(false), 1600);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.clearTimeout(hideTimer.current);
    };
  }, []);

  return (
    <aside
      className={`zine-scroll-feedback${isVisible ? " is-visible" : ""}`}
      aria-label="Why are you scrolling?"
      aria-live="polite"
    >
      <p>Why are you scrolling?</p>
      <div className="zine-scroll-feedback-counts">
        <span aria-label={`${counts.heart} hearts`}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M20.8 8.8c0 5.1-8.8 10-8.8 10s-8.8-4.9-8.8-10A4.8 4.8 0 0 1 12 6.1a4.8 4.8 0 0 1 8.8 2.7Z" />
          </svg>
          <strong>{counts.heart.toLocaleString()}</strong>
        </span>
        <span aria-label={`${counts.thumbsUp} likes`}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M7.5 10.5 11 4a2 2 0 0 1 3.7 1.1l-.4 3.4h4a2.2 2.2 0 0 1 2.1 2.8l-1.7 6.2a2.2 2.2 0 0 1-2.1 1.6h-7.1a2 2 0 0 1-2-2v-5.3Zm-4 0h3v8.6h-3a1 1 0 0 1-1-1v-6.6a1 1 0 0 1 1-1Z" />
          </svg>
          <strong>{counts.thumbsUp.toLocaleString()}</strong>
        </span>
      </div>
    </aside>
  );
};

export default ScrollFeedback;
